/**
 * DAH Association Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TaskChangeStatusRequest { 
    closedStatus?: TaskChangeStatusRequest.ClosedStatusEnum;
    comment?: string;
    projectId?: string;
    status?: TaskChangeStatusRequest.StatusEnum;
}
export namespace TaskChangeStatusRequest {
    export const ClosedStatusEnum = {
        AddedToProject: 'ADDED_TO_PROJECT',
        CreatedNewProject: 'CREATED_NEW_PROJECT',
        CompletedAsClient: 'COMPLETED_AS_CLIENT',
        NotNeed: 'NOT_NEED',
        NoAnswer: 'NO_ANSWER',
        InvalidPhoneNumber: 'INVALID_PHONE_NUMBER',
        Expensive: 'EXPENSIVE',
        OtherSoft: 'OTHER_SOFT',
        InvalidNumber: 'INVALID_NUMBER',
        NonGoal: 'NON_GOAL',
        NonLpr: 'NON_LPR',
        HousingOfficeService: 'HOUSING_OFFICE_SERVICE'
    } as const;
    export type ClosedStatusEnum = typeof ClosedStatusEnum[keyof typeof ClosedStatusEnum];
    export const StatusEnum = {
        InWork: 'IN_WORK',
        Scheduled: 'SCHEDULED',
        Done: 'DONE',
        Fail: 'FAIL'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


